/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { ModalFooter } from '@atlaskit/modal-dialog';
import { colors, codeFontFamily } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Header = styled.div({
  boxShadow: 'none',
  borderBottom: `1px solid ${token('color.border', colors.N30)}`,
});

export const Container = styled.div({
  paddingTop: token('space.200', '16px'),
  paddingBottom: token('space.200', '16px'),
});

export const LoadingContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '160px',
});

export const ConversationContainer = styled.div({
  display: 'flex',
  paddingBottom: token('space.100', '8px'),
});

export const Conversation = styled.div({
  flexGrow: 1,
  marginLeft: token('space.100', '8px'),

  /*
   * Flex children take on a "content-based minimum size" by default. With no explicit width set,
   * this value resolves to the min-content size (the smallest size the box can take that doesn't
   * lead to avoidable overflow within itself). This element has content that's set to width: 100%,
   * which resolves to the full width of the dialog. But the content is in a flex row alongside other
   * UI elements that cause this to push outside the visible modal it lives within. Setting an explicit
   * min-width value of 0 allows the container to shrink down to fit within the dialog.
   * https://drafts.csswg.org/css-flexbox/#min-size-auto
   * https://drafts.csswg.org/css-sizing-3/#min-content
   * https://css-tricks.com/flexbox-truncated-text/
   */
  minWidth: 0,
});

export const SubtitleTask = styled.div({
  paddingTop: token('space.100', '8px'),
  paddingBottom: 0,
});

export const RightAlignedFooter = styled(ModalFooter)({
  boxShadow: 'none',
  borderTop: `1px solid ${token('color.border', colors.N30)}`,
  justifyContent: 'flex-end',
});

export const CommitText = styled.span({
  fontFamily: codeFontFamily(),
});
